module.exports = __webpack_public_path__ + "img/digital01.5d355241.png";